import React from 'react';
import { ComparisonCompaniesTable } from 'dashboard409a/components';
import { ComparisonCompaniesProps } from './types';

const ComparisonCompanies = (props: ComparisonCompaniesProps) => <ComparisonCompaniesTable {...props} />;

export default ComparisonCompanies;
